import { render, staticRenderFns } from "./EmployeeSignUp.vue?vue&type=template&id=e7bfa476"
import script from "./EmployeeSignUp.vue?vue&type=script&lang=js"
export * from "./EmployeeSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports